<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" :header="$t('主体信息')" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="organizationType">
                <span slot="label"><a-tooltip>{{ $t('主体类型') }}<template slot="title">{{ $t('organization_type') }}</template></a-tooltip></span>
                <a-select v-model="form.organizationType" :placeholder="$t('请选择')" style="width: 100%" allowClear>
                  <a-select-option v-for="(item, index) in customDict.WeixinOrganizationTypeEnum" :key="index" :value="item.type">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merchantShortname">
                <span slot="label"><a-tooltip>{{ $t('商户简称') }}<template slot="title">{{ $t('merchant_shortname') }}</template></a-tooltip></span>
                <a-input v-model="form.merchantShortname" :maxLength="64" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="financeInstitution">
                <span slot="label"><a-tooltip>{{ $t('是否金融机构') }}<template slot="title">{{ $t('finance_institution') }}</template></a-tooltip></span>
                <a-radio-group v-model="form.financeInstitution" button-style="solid">
                  <a-radio v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <template v-if="form.financeInstitution">
              <a-col :span="12">
                <a-form-model-item prop="financeType">
                  <span slot="label"><a-tooltip>{{ $t('金融机构类型') }}<template slot="title">{{ $t('finance_type') }}</template></a-tooltip></span>
                  <a-select v-model="form.financeType" :placeholder="$t('请选择')" style="width: 100%" allowClear>
                    <a-select-option v-for="(item, index) in customDict.WeixinFinanceTypeEnum" :key="index" :value="item.type">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item prop="financeLicensePicList" :label-col="{ span: 2 }" :wrapper-col="{ span: 20 }">
                  <span slot="label"><a-tooltip>{{ $t('金融机构许可证图片') }}<template slot="title">{{ $t('business_addition_desc') }}</template></a-tooltip></span>
                  <oss-upload-multi :is-array-data="true" :max-count="5" v-model="form.financeLicensePicList" prefix="merchant" type="img"/>
                </a-form-model-item>
              </a-col>
            </template>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel v-if="form.organizationType!=='2401' && form.organizationType!=='2500'  " key="2" :header="$t('营业执照/登记证书')" class="goods-collapse">
          <a-row>
            <a-col :span="12" v-if="form.organizationType ==='3' || form.organizationType ==='2502'  || form.organizationType ==='1708' ">
              <a-form-model-item prop="certType">
                <span slot="label"><a-tooltip>{{ $t('证书类型') }}<template slot="title">{{ $t('cert_type') }}</template></a-tooltip></span>
                <a-select v-model="form.certType" :placeholder="$t('请选择')" style="width: 100%" allowClear>
                  <a-select-option v-for="(item, index) in customDict.WeixinCertTypeEnum" :key="index" :value="item.type">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merchantName">
                <span slot="label"><a-tooltip>{{ $t('商户名称') }}<template slot="title">{{ $t('merchant_name') }}</template></a-tooltip></span>
                <a-input v-model="form.merchantName" :maxLength="128" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="businessLicenseNumber">
                <span slot="label"><a-tooltip>{{ $t('营业执照注册号') }}<template slot="title">{{ $t('business_license_number') }}</template></a-tooltip></span>
                <a-input v-model="form.businessLicenseNumber" :maxLength="64" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="legalPerson">
                <span slot="label"><a-tooltip>{{ $t('经营者/法定代表人') }}<template slot="title">{{ $t('legal_person') }}</template></a-tooltip></span>
                <a-input v-model="form.legalPerson" :maxLength="100" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="companyAddress">
                <span slot="label"><a-tooltip>{{ $t('注册地址') }}<template slot="title">{{ $t('company_address') }}</template></a-tooltip></span>
                <a-input v-model="form.companyAddress" :maxLength="128" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="businessTime">
                <span slot="label"><a-tooltip>{{ $t('营业期限') }}<template slot="title">{{ $t('如 2020-01-01,长期') }}</template></a-tooltip></span>
                <a-date-picker style="width: 100%" v-model="form.businessTime" valueFormat="YYYY-MM-DD" allow-clear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="businessLicenseCopy">
                <span slot="label"><a-tooltip>{{ $t('营业执照图片') }}<template slot="title">{{ $t('business_license_copy') }}</template></a-tooltip></span>
                <oss-upload-single v-model="form.businessLicenseCopy" :max-size="5" prefix="merchant" type="img" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel key="3" :header="$t('经营者/法定代表人证件')" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="idHolderType">
                <span slot="label"><a-tooltip>{{ $t('证件持有人类型') }}<template slot="title">{{ $t('id_holder_type') }}</template></a-tooltip></span>
                <a-select v-model="form.idHolderType" :placeholder="$t('请选择')" style="width: 100%" allowClear>
                  <a-select-option v-for="(item, index) in customDict.WeixinIdHolderTypeEnum" :key="index" :value="item.type">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="idDocType">
                <span slot="label"><a-tooltip>{{ $t('证件类型') }}<template slot="title">{{ $t('id_doc_type') }}</template></a-tooltip></span>
                <a-select v-model="form.idDocType" :placeholder="$t('请选择')" style="width: 100%" allowClear>
                  <a-select-option v-for="(item, index) in customDict.WeixinIdentificationTypeEnum" :key="index" :value="item.type">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <template v-if="form.idDocType==='IDENTIFICATION_TYPE_MAINLAND_IDCARD' ">
              <a-col :span="12">
                <a-form-model-item prop="idCardName">
                  <span slot="label"><a-tooltip>{{ $t('身份证姓名') }}<template slot="title">{{ $t('id_card_name') }}</template></a-tooltip></span>
                  <a-input v-model="form.idCardName" :maxLength="100" :placeholder="$t('请输入')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="idCardNumber">
                  <span slot="label"><a-tooltip>{{ $t('身份证号码') }}<template slot="title">{{ $t('id_card_number') }}</template></a-tooltip></span>
                  <a-input v-model="form.idCardNumber" :maxLength="32" :placeholder="$t('请输入')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="idCardValidTimeBegin">
                  <span slot="label"><a-tooltip>{{ $t('身份证有效期开始') }}<template slot="title">{{ $t('id_card_valid_time_begin') }}</template></a-tooltip></span>
                  <a-date-picker style="width: 100%" v-model="form.idCardValidTimeBegin" valueFormat="YYYY-MM-DD" allow-clear/>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="idCardValidTime">
                  <span slot="label"><a-tooltip>{{ $t('身份证有效期结束') }}<template slot="title">{{ $t('id_card_valid_time') }}</template></a-tooltip></span>
                  <a-date-picker style="width: 100%" v-model="form.idCardValidTime" valueFormat="YYYY-MM-DD" allow-clear/>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="idCardCopy">
                  <span slot="label"><a-tooltip>{{ $t('身份证人像面') }}<template slot="title">{{ $t('id_card_copy') }}</template></a-tooltip></span>
                  <oss-upload-single v-model="form.idCardCopy" style="width:100px;height:80px" :max-size="5" prefix="merchant" type="img" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="idCardNational">
                  <span slot="label"><a-tooltip>{{ $t('身份证国徽面') }}<template slot="title">{{ $t('id_card_national') }}</template></a-tooltip></span>
                  <oss-upload-single v-model="form.idCardNational" style="width:100px;height:80px" :max-size="5" prefix="merchant" type="img" />
                </a-form-model-item>
              </a-col>
            </template>
            <template v-else>
              <a-col :span="12">
                <a-form-model-item prop="idDocName">
                  <span slot="label"><a-tooltip>{{ $t('证件姓名') }}<template slot="title">{{ $t('id_doc_name') }}</template></a-tooltip></span>
                  <a-input v-model="form.idDocName" :maxLength="100" :placeholder="$t('请输入')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="idDocNumber">
                  <span slot="label"><a-tooltip>{{ $t('证件号码') }}<template slot="title">{{ $t('id_doc_number') }}</template></a-tooltip></span>
                  <a-input v-model="form.idDocNumber" :maxLength="64" :placeholder="$t('请输入')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="docPeriodBegin">
                  <span slot="label"><a-tooltip>{{ $t('证件开始日期') }}<template slot="title">{{ $t('doc_period_begin') }}</template></a-tooltip></span>
                  <a-input v-model="form.docPeriodBegin" :maxLength="10" placeholder="YYYY-MM-DD" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="docPeriodEnd">
                  <span slot="label"><a-tooltip>{{ $t('证件结束日期') }}<template slot="title">{{ $t('doc_period_end') }}</template></a-tooltip></span>
                  <a-input v-model="form.docPeriodEnd" :maxLength="32" placeholder="YYYY-MM-DD 或 长期" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="idDocCopy">
                  <span slot="label"><a-tooltip>{{ $t('证件正面') }}<template slot="title">{{ $t('id_doc_copy') }}</template></a-tooltip></span>
                  <oss-upload-single v-model="form.idDocCopy" style="width:100px;height:80px" :max-size="5" prefix="merchant" type="img" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="idDocCopyBack">
                  <span slot="label"><a-tooltip>{{ $t('证件反面') }}<template slot="title">{{ $t('id_doc_copy_back') }}</template></a-tooltip></span>
                  <oss-upload-single v-model="form.idDocCopyBack" style="width:100px;height:80px" :max-size="5" prefix="merchant" type="img" />
                </a-form-model-item>
              </a-col>
            </template>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel key="4" :header="$t('结算账户')" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="bankAccountType">
                <span slot="label"><a-tooltip>{{ $t('账户类型') }}<template slot="title">{{ $t('bank_account_type') }}</template></a-tooltip></span>
                <a-radio-group v-model="form.bankAccountType" button-style="solid" >
                  <a-radio-button v-for="(item, index) in customDict.WeixinBankAccountTypeEnum" :key="index" :value="item.type">{{ item.name }}</a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="accountName">
                <span slot="label"><a-tooltip>{{ $t('开户名称') }}<template slot="title">{{ $t('account_name') }}</template></a-tooltip></span>
                <a-input v-model="form.accountName" :maxLength="128" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="accountNumber">
                <span slot="label"><a-tooltip>{{ $t('银行账号') }}<template slot="title">{{ $t('account_number') }}</template></a-tooltip></span>
                <a-input v-model="form.accountNumber" :maxLength="128" :placeholder=" $t('请输入')" @change="onAccountNumberChange">
                  <a-icon v-if="bankQueryLoading" slot="suffix" type="loading" />
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="accountBank">
                <span slot="label"><a-tooltip>{{ $t('开户银行') }}<template slot="title">{{ $t('account_bank') }}</template></a-tooltip></span>
                <a-auto-complete class="global-search"  v-model="form.accountBank"  style="width: 100%" placeholder="请输入开户银行查询" option-label-prop="title"
                                 @select="handleBankChange"
                                 @search="handleBankSearch">
                  <template slot="dataSource">
                    <a-select-option v-for="item in bankList" :key="item.bankAlias" :title="item.bankAlias">
                      {{ item.bankAlias }}
                    </a-select-option>
                  </template>
                </a-auto-complete>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="bankName">
                <span slot="label"><a-tooltip>{{ $t('开户银行全称') }}<template slot="title">{{ $t('bank_name') }}</template></a-tooltip></span>
                <a-button  @click="$refs.RadioBranchSelectForm.openBranch(form.accountBank)" style="text-align: left; width: 100%" >
                  <span style="color: dodgerblue">{{this.getBranchName()}} </span>
                </a-button>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="bankBranchId">
                <span slot="label"><a-tooltip>{{ $t('开户银行联行号') }}<template slot="title">{{ $t('bank_branch_id') }}</template></a-tooltip></span>
                <a-input disabled v-model="form.bankBranchId" :maxLength="64" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel key="5" :header="$t('超级管理员')" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="contactType">
                <span slot="label"><a-tooltip>{{ $t('管理员类型') }}<template slot="title">{{ $t('contact_type') }}</template></a-tooltip></span>
                <a-radio-group v-model="form.contactType" button-style="solid">
                  <a-radio-button v-for="(item, index) in customDict.WeixinContactTypeEnum" :key="index" :value="item.type">{{ item.name }}</a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactName">
                <span slot="label"><a-tooltip>{{ $t('管理员姓名') }}<template slot="title">{{ $t('contact_name') }}</template></a-tooltip></span>
                <a-input v-model="form.contactName" :maxLength="100" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="mobilePhone">
                <span slot="label"><a-tooltip>{{ $t('管理员手机') }}<template slot="title">{{ $t('mobile_phone') }}</template></a-tooltip></span>
                <a-input v-model="form.mobilePhone" :maxLength="20" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <template v-if="form.contactType=== '66' ">
              <a-col :span="12">
                <a-form-model-item prop="contactIdDocType">
                  <span slot="label"><a-tooltip>{{ $t('管理员证件类型') }}<template slot="title">{{ $t('contact_id_doc_type') }}</template></a-tooltip></span>
                  <a-select v-model="form.contactIdDocType" :placeholder="$t('请选择')" style="width: 100%" allowClear>
                    <a-select-option v-for="(item, index) in customDict.WeixinIdentificationTypeEnum" :key="index" :value="item.type">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="contactIdCardNumber">
                  <span slot="label"><a-tooltip>{{ $t('管理员证件号码') }}<template slot="title">{{ $t('contact_id_card_number') }}</template></a-tooltip></span>
                  <a-input v-model="form.contactIdCardNumber" :maxLength="64" :placeholder="$t('请输入')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="contactIdDocCopy">
                  <span slot="label"><a-tooltip>{{ $t('管理员证件正面') }}<template slot="title">{{ $t('contact_id_doc_copy') }}</template></a-tooltip></span>
                  <oss-upload-single v-model="form.contactIdDocCopy" style="width:100px;height:80px" :max-size="5" prefix="merchant" type="img" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="contactIdDocCopyBack">
                  <span slot="label"><a-tooltip>{{ $t('管理员证件反面') }}<template slot="title">{{ $t('contact_id_doc_copy_back') }}</template></a-tooltip></span>
                  <oss-upload-single v-model="form.contactIdDocCopyBack" style="width:100px;height:80px" :max-size="5" prefix="merchant" type="img" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="contactIdDocPeriodBegin">
                  <span slot="label"><a-tooltip>{{ $t('证件有效期开始') }}<template slot="title">{{ $t('contact_id_doc_period_begin') }}</template></a-tooltip></span>
                  <a-date-picker style="width: 100%" v-model="form.contactIdDocPeriodBegin" valueFormat="YYYY-MM-DD" allow-clear/>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="contactIdDocPeriodEnd">
                  <span slot="label"><a-tooltip>{{ $t('证件有效期结束') }}<template slot="title">{{ $t('contact_id_doc_period_end') }}</template></a-tooltip></span>
                  <a-date-picker style="width: 100%" v-model="form.contactIdDocPeriodEnd" valueFormat="YYYY-MM-DD" allow-clear/>
                </a-form-model-item>
              </a-col>
            </template>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel key="6" :header="$t('经营场景')" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="storeName">
                <span slot="label"><a-tooltip>{{ $t('店铺名称') }}<template slot="title">{{ $t('store_name') }}</template></a-tooltip></span>
                <a-input v-model="form.storeName" :maxLength="256" :placeholder="$t('请输入')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="storeUrl">
                <span slot="label"><a-tooltip>{{ $t('店铺链接') }}<template slot="title">{{ $t('store_url，与店铺二维码二选一') }}</template></a-tooltip></span>
                <a-input v-model="form.storeUrl" :maxLength="1024" :placeholder="$t('https://')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="storeQrCode">
                <span slot="label"><a-tooltip>{{ $t('店铺二维码') }}<template slot="title">{{ $t('store_qr_code') }}</template></a-tooltip></span>
                <oss-upload-single v-model="form.storeQrCode" :max-size="5" prefix="merchant" type="img" />
              </a-form-model-item>
            </a-col>
<!--            <a-col :span="12">
              <a-form-model-item prop="qualificationType">
                <span slot="label"><a-tooltip>{{ $t('所属行业') }}<template slot="title">{{ $t('qualification_type') }}</template></a-tooltip></span>
                <a-input v-model="form.qualificationType" :maxLength="200" :placeholder="$t('选填')" />
              </a-form-model-item>
            </a-col>-->
            <a-col :span="24">
              <a-form-model-item prop="businessAdditionDesc" :label-col="{ span: 2 }" :wrapper-col="{ span: 20 }">
                <span slot="label"><a-tooltip>{{ $t('补充说明') }}<template slot="title">{{ $t('business_addition_desc') }}</template></a-tooltip></span>
                <a-textarea v-model="form.businessAdditionDesc" :rows="2" :placeholder="$t('选填')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item prop="businessAdditionPicList" :label-col="{ span: 2 }" :wrapper-col="{ span: 20 }">
                <span slot="label"><a-tooltip>{{ $t('附件') }}<template slot="title">{{ $t('business_addition_desc') }}</template></a-tooltip></span>
                <oss-upload-multi :is-array-data="true" :max-count="5" v-model="form.businessAdditionPicList" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
      </a-collapse>

      <radio-branch-select-form ref="RadioBranchSelectForm" @branchSelect="indexBranchSelect"></radio-branch-select-form>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getExtraApplyWeixin, addExtraApplyWeixin, updateExtraApplyWeixin, queryWeixinBankByAccount } from '@/api/merchant/extraApplyWeixin'
import { getApplyByMerchantId } from '@/api/merchant/merchantApply'
import { mapGetters } from 'vuex'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import OssUploadMulti from "@/components/OssUploadMulti/index.vue";
import RadioBranchSelectForm from "@/views/merchant/branch/modules/RadioSelectForm.vue";
import {listBank} from "@/api/merchant/bank";
const MAINLAND_IDCARD = 'IDENTIFICATION_TYPE_MAINLAND_IDCARD'

export default {
  name: 'CreateForm',
  props: {
    merchantId: {
      type: String,
      required: true
    },
    merchantType: {
      type: Number,
      required: true,
      default: 1
    }
  },
  components: {
    RadioBranchSelectForm,
    OssUploadMulti,
    OssUploadSingle
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: this.$t('请填写真实信息') + '（/v3/ecommerce/applyments/）',
      activeKey: ['1', '2', '3', '4', '5', '6'],
      formType: 1,
      open: false,
      form: this.emptyForm(),
      bankList: [],
      bankQueryLoading: false,
      accountNumberQueryTimer: null,
      rules: {
        organizationType: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        merchantName: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        legalPerson: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        companyAddress: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        businessLicenseCopy:  [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        businessLicenceNo: [{required: true, message: this.$t('不能为空'), trigger: 'blur'}],
        businessTime: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        bankAccountType: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        accountBank: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        accountName: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        bankBranchId: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        bankName: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        accountNumber: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        contactType: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        contactName: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        mobilePhone: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        qualificationType: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        merchantShortname: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        contactIdCardNumber: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        contactIdDocCopy: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        contactIdDocCopyBack: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        contactIdDocPeriodBegin: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        contactIdDocPeriodEnd: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        storeName: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        contactIdDocType: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        idHolderType:  [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        idDocType: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        idCardCopy: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        idCardNational: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        idCardName: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        idCardNumber: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        idCardValidTimeBegin: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        idCardValidTime: [{ required: true, message: this.$t('不能为空'), trigger: 'change' }],
        idDocName: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        idDocNumber: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        idDocCopy: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        idDocCopyBack: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        docPeriodBegin: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        docPeriodEnd: [{ required: true, message: this.$t('不能为空'), trigger: 'blur' }],
        businessAdditionPicList: [{ required: false, message: this.$t('不能为空'), trigger: 'change' }],
        businessAdditionDesc: [{ required: false, message: this.$t('不能为空'), trigger: 'blur' }],
      }
    }
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        merchantId: this.merchantId ? Number(this.merchantId) : null,
        organizationType: undefined,
        financeInstitution: false,
        financeType: undefined,
        financeLicensePicList: [],
        idHolderType: 'LEGAL',
        idDocType: MAINLAND_IDCARD,
        certType: 'CERTIFICATE_TYPE_2389',
        businessLicenseCopy: null,
        businessLicenseNumber: null,
        merchantName: null,
        legalPerson: null,
        companyAddress: null,
        businessTime: null,
        idCardCopy: null,
        idCardNational: null,
        idCardName: null,
        idCardNumber: null,
        idCardValidTimeBegin: null,
        idCardValidTime: null,
        idDocName: null,
        idDocNumber: null,
        idDocCopy: null,
        idDocCopyBack: null,
        docPeriodBegin: null,
        docPeriodEnd: null,
        bankAccountType: '75',
        accountBank: null,
        accountName: null,
        bankBranchId: null,
        bankName: null,
        accountNumber: null,
        contactType: '65',
        contactName: null,
        contactIdDocType: undefined,
        contactIdCardNumber: null,
        contactIdDocCopy: null,
        contactIdDocCopyBack: null,
        contactIdDocPeriodBegin: null,
        contactIdDocPeriodEnd: null,
        mobilePhone: null,
        storeName: null,
        storeUrl: null,
        storeQrCode: null,
        qualificationType: null,
        merchantShortname: null,
        businessAdditionDesc: null,
        businessAdditionPicList: [],
      }
    },
    onAccountNumberChange() {
      if (this.form.bankAccountType !== '75') {
        return
      }
      const no = (this.form.accountNumber || '').replace(/\s/g, '')
      if (no.length < 15) {
        return
      }
      clearTimeout(this.accountNumberQueryTimer)
      this.accountNumberQueryTimer = setTimeout(() => {
        this.queryBankByAccount(no)
      }, 500)
    },
    queryBankByAccount(no) {
      this.bankQueryLoading = true
      queryWeixinBankByAccount(no)
        .then(response => {
          const list = response.data || []
          if (list.length === 0) {
            this.$message.warning(this.$t('未查询到开户银行信息'))
            return
          }
          if (list.length === 1) {
            this.form.accountBank = list[0].accountBank
            return
          }
          this.form.accountBank = null
          this.$message.info(this.$t('查询到多家银行，请手动选择'))
        })
        .finally(() => {
          this.bankQueryLoading = false
        })
    },

    defaultOrganizationType() {
      if (this.merchantType === 1) {
        return '2'
      }
      if (this.merchantType === 2) {
        return '2401'
      }
      if (this.merchantType === 4) {
        return '3'
      }
      return undefined
    },
    onClose() {
      this.cancel()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      clearTimeout(this.accountNumberQueryTimer)
      this.formType = 1
      this.form = this.emptyForm()
      this.bankQueryLoading = false
    },
    handleAdd(merchantId) {
      this.reset()
      this.formType = 1
      this.form.merchantId = merchantId
      this.form.organizationType = this.defaultOrganizationType()
      if (this.merchantType === 1) {
        this.form.bankAccountType = '74'
      }
      getApplyByMerchantId({ id: merchantId || this.merchantId }).then(response => {
        if (!response.data) {
          return
        }
        const d = response.data
        this.form.merchantName = d.merchantName
        this.form.merchantShortname = d.merchantName
        this.form.storeName = d.merchantName
        this.form.companyAddress = d.merchantAreaxName + d.merchantAddress;
        if (this.merchantType === 1) {
          this.form.businessLicenseNumber = d.businessLicenceNo
          this.form.businessLicenseCopy = d.businessLicenseImg
        }
        this.form.legalPerson = d.contactName
        this.form.idCardName = d.contactName
        this.form.idCardNumber = d.contactCardNo
        this.form.idCardCopy = d.contactCardFace
        this.form.idCardNational = d.contactCardNational
        this.form.contactName = d.contactName
        this.form.mobilePhone = d.contactPhone
        this.form.accountName = d.accountName
        this.form.accountNumber = d.accountNo
        if (d.accountNo && this.form.bankAccountType === '75') {
          this.onAccountNumberChange()
        }
        if (d.branchResult) {
          this.indexBranchSelect({name: d.branchResult.name, code: d.branchResult.code, bankAlias: d.branchResult.bankAlias,})
          this.form.accountNo = d.accountNo
          this.form.accountHolderName = d.accountName
        }
      })
      this.open = true
    },

    //银行选择
    handleBankSearch(value) {
      if (value === undefined) {
        return;
      }
      if (value === '') {
        return;
      }
      listBank({"bankAlias": value}).then(response => {
        this.bankList = response.data
      })
    },
    handleBankChange(value) {
      console.log('搜索选中了银行信息:',value)
      this.form.accountBank = value;
    },
    getBranchName() {
      if (this.form.bankName) {
        return this.form.bankName
      } else {
        return this.$t('请选择')+'开户行名称'
      }
    },
    indexBranchSelect(record) {
      console.log('选中了银行:',record)
      this.form.bankName = record.name;
      this.form.accountBank = record.bankAlias
      this.form.bankBranchId = record.code;
    },


    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getExtraApplyWeixin({ id }).then(response => {
        this.form = { ...this.emptyForm(), ...response.data }
        if (this.form.accountNumber && this.form.bankAccountType === '75') {
          this.onAccountNumberChange()
        }
        this.open = true
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        if (this.formType === 2 && this.form.id) {
          updateExtraApplyWeixin(this.form)
            .then(response => {
              if (response.code === '20001') {
                this.$message.success(this.$t('修改成功'), 3)
                this.open = false
                this.$emit('ok')
              }
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          addExtraApplyWeixin(this.form)
            .then(response => {
              if (response.code === '20001') {
                this.$message.success(this.$t('新增成功'), 3)
                this.open = false
                this.$emit('ok')
              }
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
.goods-collapse > .ant-collapse-header {
  color: #0e75d3 !important;
  background: #e8eef9;
}
</style>
